exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:AvenirNext;font-weight:400;src:url(/font/AvenirNext-Regular.ttf) format(\"truetype\")}@font-face{font-family:AvenirNext;font-weight:700;src:url(/font/AvenirNext-DemiBold.ttf) format(\"truetype\")}", ""]);

// exports
